import { configureStore } from '@reduxjs/toolkit';
import bridgeReducer from './futures/bridge/bridgeSlice.js';

export default configureStore({
  reducer: {
    bridge: bridgeReducer
  },
})